import React, { FC } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { Button, useTheme } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

const BackButton: FC<ButtonProps> = ({ onClick, ...restProps }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Button
      {...restProps}
      onClick={onClick}
      variant="contained"
      color="secondary"
      disableElevation={true}
      startIcon={
        <FontAwesomeSpriteIcon
          icon={SpriteIconsLight.BACK_BUTTON}
          color={theme.palette.common.white}
        />
      }
    >
      {t('shared.back')}
    </Button>
  );
};

export default BackButton;
